import { isOnlineOrRecent } from '@utils/isOnlineOrRecent'
import { colors, size } from '@styles/theme'
import styled from '@emotion/styled'

import StatusIndicator from './StatusIndicator'
import { Link } from 'react-router-dom'
import { Avatar } from '@mui/material'

const StyledAvatar = styled(Avatar)`
  height: ${size(3.5)};
  width: ${size(3.5)};
`

const OnlineIndicator = styled.div`
  position: absolute;
  top: 21.5%;
  right: -5%;
  border-radius: 100px;
  flex-shrink: 0;
`

const ProfileNavigateAvatar = ({ user, uuid, src, canNavigate=true, linkProps, children, toNearby=true, userStatus, statusSize=2.5, onlineIndicator=false, onlineIndSize=1.25, onlineIndPos={}, replace=false, allowEventPropogation=false, ...rest }) => {

  const renderOnlineIndicator = () => {
    const { isOnline, isRecent } = isOnlineOrRecent(user)

    return (
      <OnlineIndicator
        style={{
          height: size(onlineIndSize),
          width: size(onlineIndSize),
          backgroundColor: isOnline ? colors.onlineIndicator() : (isRecent ? colors.recentIndicator() : ''),
          ...onlineIndPos,
        }}
      />
    )
  }

  return (
    <Link
      replace={replace}
      to={canNavigate && (toNearby ? `/map?screen_modal=nearby-profile&nearby_uuid=${uuid}` : `/profiles/${uuid}`)}
      onClick={(e) => {
        if (!canNavigate) e.preventDefault()
        if (!allowEventPropogation) {
          e.stopPropagation()
        }
      }}
      style={{ borderRadius: '100%', position: 'relative' }}
      {...linkProps}>
      <StyledAvatar
        alt='User Picture Or Avatar'
        src={src}
        {...rest}>
        {children}
      </StyledAvatar>
      {userStatus && userStatus !== 'browsing' &&
        <StatusIndicator
          status={userStatus}
          containerStyles={{
            position: 'absolute',
            top: '-2.5%',
            left: '-5%',
            height: size(statusSize),
            width: size(statusSize),
          }}
        />
      }
      {onlineIndicator && renderOnlineIndicator()}
    </Link>
  )
}

export default ProfileNavigateAvatar
